export const australiaFaq = [
    {
        question: "How do I prepare for a house sitting assignment?",
        answer: "Prepare by communicating with the homeowner about their specific needs, checking the house sit listing details, and packing essentials like pet care supplies and maintenance tools.",
    },
    {
        question: "Are utilities included when I house sit?",
        answer: " Most house sitting roles include free accommodation, and some may include utilities like electricity and water, but this varies by homeowner.",
    },
    {
        question: "What happens if I need help during my house sitting assignment?",
        answer: "HouseSit Match provides a support system for its members, and you can also reach out to the homeowner for assistance.",
    },
    {
        question: "Can I apply for multiple house sitting opportunities at once?",
        answer: "Yes, you can apply for multiple listings that fit your schedule and interests.",
    },
    {
        question: "Are there any unique aspects I should be aware of?",
        answer: "House sitting in Australia may involve taking care of native animals like kangaroos or wildlife such as possums. Understanding the local environment and any regional wildlife precautions is important.",
    },
];

export const canadaFaq = [
    {
        question: "Can I house sit in Canada if I'm not a resident?",
        answer: "Yes, travelers from abroad can house sit in Canada. However, it's important to check the visa requirements if you're traveling from outside the country.",
    },
    {
        question: "How can I find house sitting opportunities in Canada?",
        answer: "You can find opportunities by signing up on HouseSit Match, where homeowners list their properties and pet care needs.",
    },
    {
        question: "Do I need experience in pet care to be a house sitter?",
        answer: "While experience in pet care is beneficial, it's not always required. Homeowners may provide specific instructions on pet care if needed. Demonstrating responsibility and a love for animals can be equally important.",
    },
    {
        question: "What are the responsibilities of a house sitter?",
        answer: "Responsibilities generally include looking after the homeowner's pets, maintaining the home (watering plants, collecting mail), and ensuring the safety and security of the property.",
    },
    {
        question: "Can I choose the location where I want to house sit in Canada?",
        answer: "Yes, platforms like HouseSit Match allow you to browse available listings by location, making it easy to choose where you want to house sit based on your interests and travel plans.",
    },
];

export const europeFaq = [
    {
        question: "Do I need a work visa to house sit in Europe?",
        answer: "No, house sitting is typically considered a voluntary exchange, so a tourist visa is usually sufficient for short stays.",
    },
    {
        question: "What should I include in my house sitting agreement?",
        answer: "Ensure the agreement covers responsibilities like pet care, security tasks, and emergency contacts.",
    },
    {
        question: "Are there pet-specific rules I need to know about?",
        answer: "Yes, research local pet care requirements, including vaccinations or leash laws, before starting the assignment.",
    },
    {
        question: "Can I bring my pet while house sitting in Europe?",
        answer: "This depends on the homeowner. Always discuss this upfront during the application process.",
    },
    {
        question: "How far in advance should I apply for house sitting jobs?",
        answer: "Apply 1-3 months ahead for the best chances, especially for popular destinations.",
    },
];

export const usaFaq = [
    {
        question: "Are house sitting assignments available in smaller US towns?",
        answer: "Yes, house sitting opportunities are available in both major cities and smaller towns, giving sitters the chance to explore less touristy areas while enjoying a more local experience.",
    },
    {
        question: "Is house sitting in the USA safe?",
        answer: "Platforms like HouseSit Match ensure safety through ID checks and support services for both parties.",
    },
    {
        question: "What types of pets might I care for in the USA?",
        answer: "Common pets include dogs and cats, but some assignments involve farm animals or exotic pets.",
    },
    {
        question: "Is house sitting in the USA suitable for families?",
        answer: "Yes, some assignments welcome families, providing a unique way to explore the USA together while staying in a comfortable home environment.",
    },
    {
        question: "Are there house sitting opportunities in the USA for long road trips?",
        answer: "Yes, the USA's vast geography often includes assignments perfect for road trippers, allowing sitters to explore different regions while staying in various homes across the country.",
    },
];

export const defaultFaq = [
    {
        question: "What are the most popular destinations for house sitting abroad?",
        answer: "Countries like the UK, Australia, Canada, and France are popular, but opportunities exist worldwide, including in off-the-beaten-path locations.",
    },
    {
        question: "Can I house sit abroad as part of a couple or family?",
        answer: "Yes, many homeowners welcome couples or families, especially for larger properties or more complex responsibilities.",
    },
    {
        question: "Do I need special skills to house sit abroad?",
        answer: "While no special skills are required, experience with pets, gardening, or managing a property can enhance your profile.",
    },
    {
        question: "Is house sitting abroad a paid opportunity?",
        answer: "Most house sitting jobs are based on a mutual exchange—free accommodation in return for care. However, some specialised roles may offer payment.",
    },
    {
        question: "What should I do in case of an emergency while house sitting abroad?",
        answer: "Ensure you have contact information for the homeowner, local emergency services, and any relevant pet care providers. Platforms like HouseSit Match also offer guidance and resources to help you handle unexpected situations. Plus we ask for your emergency contact telephone numbers to ensure there is always someone to call in the unlikely event of a crisis.",
    },
];